var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fill-height" },
    [
      _c(
        "v-card",
        { staticClass: "rounded-lg fill-height", attrs: { justify: "center" } },
        [
          _c(
            "v-tabs",
            {
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _vm.app.show100ms ? _c("v-tab", [_vm._v("100ms")]) : _vm._e(),
              _c("v-tab", [_vm._v("Integrations")]),
              _c("v-tab", [_vm._v("Webhooks")]),
            ],
            1
          ),
          _c(
            "v-tabs-items",
            {
              staticClass: "fill-height",
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _vm.app.show100ms
                ? _c("v-tab-item", [_c("one-hundred-ms-settings")], 1)
                : _vm._e(),
              _c(
                "v-tab-item",
                { staticClass: "fill-height" },
                [_c("integrations")],
                1
              ),
              _c("v-tab-item", [_c("webhooks")], 1),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }